import React, { useState, useEffect } from "react";
import { Box, DialogActions, DialogContent } from "@mui/material";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import DropDownComponent from "../../../atom/Inputs/DropDown";
import { DatePickerComponent, TimePickerComponent } from "../../../atom";
import { useDispatch } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import { connect } from "react-redux";
import {
  convertStringDate,
} from "../../../../core/Constant";

const AdminwebinarForm = ({ onClose, courseList, getCourseList }) => {
  const dispatch = useDispatch();
  const [newWebinar, setNewWebinar] = useState({
    name: "",
    date: "",
    time: "",
    time_ext: "AM",
    duration: "",
    is_recurring: "false",
    recurrence_type: 2,
    repeat_interval: 1,
    weekly_days: "",
    monthly_day: "",
    end_times: "",
    end_date_time: "",
    course: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    date: "",
    time: "",
    duration: "",
    is_recurring: "",
    recurrence_type: "",
    repeat_interval: "",
    weekly_days: "",
    monthly_day: "",
    end_times: "",
    end_date_time: "",
    course: "",
  });
  const [courseId, setCourseId] = useState(0);

  useEffect(() => {}, [errors, courseList]);

  useEffect(() => {
    getCourseList();
  }, []);

  const emptyFormfields = () => {
    setNewWebinar({
      name: "",
      date: "",
      time: "",
      time_ext: "AM",
      duration: "",
      is_recurring: "false",
      recurrence_type: 2,
      repeat_interval: 1,
      weekly_days: "",
      monthly_day: "",
      end_times: "",
      end_date_time: "",
      course: "",
    });
  };

  const validateForm = () => {
    const newErrors = {
      name: "",
      date: "",
      time: "",
      duration: "",
      is_recurring: "",
      recurrence_type: "",
      repeat_interval: "",
      weekly_days: "",
      monthly_day: "",
      end_times: "",
      end_date_time: "",
      course: "",
    };

    if (!newWebinar?.name) {
      newErrors.name = "Webinar title is required";
    } else if (newWebinar.name.length < 2) {
      newErrors.name = "Title must be at least 2 characters";
    } else if (newWebinar.name.length > 200) {
      newErrors.name = "Title must be at most 200 characters";
    }
    if (!newWebinar?.date) {
      newErrors.date = "Date is required";
    }

    if (!newWebinar?.time) {
      newErrors.time = "Time is required";
    }

    if (!newWebinar?.duration) {
      newErrors.duration = "Duration is required";
    }

    if (newWebinar.is_recurring === "true") {
      if (!newWebinar.recurrence_type) {
        newErrors.recurrence_type = "Recurrence type is required";
      }
      if (!newWebinar.repeat_interval) {
        newErrors.repeat_interval = "Repeat interval is required";
      }
      if (Number(newWebinar.recurrence_type) === 2 && !newWebinar.weekly_days) {
        newErrors.weekly_days = "Weekly days are required for weekly recurrence";
      }
      if (Number(newWebinar.recurrence_type) === 3 && !newWebinar.monthly_day) {
        newErrors.monthly_day = "Monthly day is required for monthly recurrence";
      }
      if (!newWebinar.end_times && !newWebinar.end_date_time) {
        newErrors.end_times = "Either end times or end date/time is required";
        newErrors.end_date_time = "Either end times or end date/time is required";
      }
    }

    setErrors(newErrors);

    // Return true if there are no errors
    return Object.values(newErrors).every((error) => !error);
  };

  const handleChange = async (name, value) => {
    if (name == "course") {
      setCourseId(value);
    }
  if (name === "end_times") {
    setNewWebinar({
      ...newWebinar,
      end_times: value,
      end_date_time: "",
    });
    return;
  }

  if (name === "end_date_time") {
    setNewWebinar({
      ...newWebinar,
      end_date_time: value,
      end_times: "",
    });
    return;
  }

  setNewWebinar({
    ...newWebinar,
    [name]: value,
  });
};

  const handleSubmit = async (event) => {
    event.preventDefault();

  if (!validateForm()) return;

  // Format date
  const formattedDate = convertStringDate(newWebinar.date);

  // Format time
  let timeStr = "";
  let timeExt = newWebinar.time_ext || "AM";

  if (newWebinar.time?.$d) {
    let hours = newWebinar.time.$H;
    const minutes = newWebinar.time.$m;

    if (hours >= 12) {
      timeExt = "PM";
      if (hours > 12) hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }

    timeStr = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  } else {
    timeStr = newWebinar.time;
  }

  const payload = {
    name: newWebinar.name,
    date: formattedDate,
    time: timeStr,
    time_ext: timeExt,
    duration: Number(newWebinar.duration),
    is_recurring: newWebinar.is_recurring === "true" ? true : false,
  };

  if (payload.is_recurring) {
    payload.recurrence_type = Number(newWebinar.recurrence_type);
    payload.repeat_interval = Number(newWebinar.repeat_interval);

    if (Number(newWebinar.recurrence_type) === 2 && newWebinar.weekly_days) {
      payload.weekly_days = newWebinar.weekly_days.toString(); // keep as comma-separated string
    }

    if (Number(newWebinar.recurrence_type) === 3 && newWebinar.monthly_day) {
      payload.monthly_day = Number(newWebinar.monthly_day);
    }

    if (newWebinar.end_times) {
      payload.end_times = Number(newWebinar.end_times);
    } else if (newWebinar.end_date_time) {
      payload.end_date_time = new Date(newWebinar.end_date_time).toISOString();
    }
  }

  dispatch(Actions.webinar.createWebinarAdmin(payload))
    .then((res) => {
      if (!res?.error) {
        onClose();
        emptyFormfields();
        dispatch(Actions.webinar.getAllWebinarsAdmin());
      } else {
        console.error("Create webinar failed", res.error);
      }
    })
    .catch((err) => {
      console.error("Create webinar exception", err);
    });
};

  return (
    <>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box>
            <Box>
              <TextInputComponent
                label={"Webinar Title"}
                placeholder="Enter webinar title"
                name="name"
                value={newWebinar.name}
                onchange={(e) => handleChange("name", e.target.value)}
                readOnly={false}
                isError={errors?.name !== ""}
                error={errors?.name}
                required
              />
            </Box>
            <Box>
              <DatePickerComponent
                label={"Date"}
                selected={newWebinar.date}
                dateFormat="dd/MM/yyyy"
                onChange={(e) => handleChange("date", e)}
                isError={errors?.date !== "" ? true : false}
                error={errors?.date}
                minDate={new Date()}
              />
            </Box>

            <Box>
              <TimePickerComponent
                value={newWebinar.time}
                onChange={(e) => handleChange("time", e)}
                isError={errors?.time !== "" ? true : false}
                error={errors?.time}
              />
            </Box>

            <Box>
              <TextInputComponent
                label={"Duration (MIN)"}
                placeholder="Enter Webinar duration"
                name="duration"
                type="number"
                value={newWebinar.duration}
                onchange={(e) => handleChange("duration", e.target.value)}
                readOnly={false}
                isError={errors?.duration !== "" ? true : false}
                error={errors?.duration}
              />
            </Box>

            <Box sx={{ mt: 2 }}>
              <DropDownComponent
                list={[
                  { id: "false", name: "No (One-time)" },
                  { id: "true", name: "Yes (Recurring)" },
                ]}
                dropdownLabel={"Is Recurring?"}
                initialValue={"Select"}
                selectedValue={newWebinar.is_recurring}
                onchange={(e) => handleChange("is_recurring", e.target.value)}
              />
            </Box>

            {newWebinar.is_recurring === "true" && (
              <>
                <Box sx={{ mt: 2 }}>
                  <DropDownComponent
                    list={[
                      { id: 1, name: "Daily" },
                      { id: 2, name: "Weekly" },
                      { id: 3, name: "Monthly" },
                    ]}
                    dropdownLabel={"Recurrence Type"}
                    initialValue={"Select"}
                    selectedValue={newWebinar.recurrence_type}
                    onchange={(e) => handleChange("recurrence_type", Number(e.target.value))}
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <TextInputComponent
                    label={"Repeat Interval"}
                    placeholder="e.g. every 2 weeks = 2"
                    name="repeat_interval"
                    type="number"
                    value={newWebinar.repeat_interval}
                    onchange={(e) => handleChange("repeat_interval", e.target.value)}
                    readOnly={false}
                    isError={errors?.repeat_interval !== ""}
                    error={errors?.repeat_interval}
                  />
                </Box>

                {newWebinar.recurrence_type === 2 && (
                  <Box sx={{ mt: 2 }}>
                    <TextInputComponent
                      label={"Weekly Days (comma-separated, 1=Sun, 2=Mon,...)"}
                      placeholder="e.g. 2,4 for Mon,Wed"
                      name="weekly_days"
                      value={newWebinar.weekly_days}
                      onchange={(e) => handleChange("weekly_days", e.target.value)}
                      readOnly={false}
                      isError={errors?.weekly_days !== ""}
                      error={errors?.weekly_days}
                    />
                  </Box>
                )}

                {newWebinar.recurrence_type === 3 && (
                  <Box sx={{ mt: 2 }}>
                    <TextInputComponent
                      label={"Monthly Day (1-31)"}
                      placeholder="e.g. 15"
                      name="monthly_day"
                      type="number"
                      value={newWebinar.monthly_day}
                      onchange={(e) => handleChange("monthly_day", e.target.value)}
                      readOnly={false}
                      isError={errors?.monthly_day !== ""}
                      error={errors?.monthly_day}
                    />
                  </Box>
                )}

                <Box sx={{ mt: 2 }}>
                  <TextInputComponent
                    label={"End Times (number of occurrences)"}
                    placeholder="e.g. 10"
                    name="end_times"
                    type="number"
                    value={newWebinar.end_times}
                    onchange={(e) => handleChange("end_times", e.target.value)}
                    readOnly={false}
                    isError={errors?.end_times !== ""}
                    error={errors?.end_times}
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <DatePickerComponent
                    label={"End Date Time"}
                    selected={newWebinar.end_date_time}
                    onChange={(e) => handleChange("end_date_time", e)}
                    isError={errors?.end_date_time !== ""}
                    error={errors?.end_date_time}
                    minDate={newWebinar.date ? new Date(newWebinar.date) : new Date()}
                    showTimeSelect
                    dateFormat="yyyy-MM-dd'T'HH:mm:ss'Z'"
                    placeholderText="Select end date and time"
                  />
                </Box>
              </>
            )}
            
          </Box>
        </DialogContent>
        <DialogActions sx={{ mr: 2, mb: 2 }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            <TextButtonComponet
              text={"Add"}
              width={120}
              onButtonClick={handleSubmit}
            />
            <TextButtonComponet
              text={"Cancel"}
              classStyle="btn btn-secondary"
              width={120}
              onButtonClick={() => {
                onClose();
                emptyFormfields();
                setErrors();
              }}
            />
          </Box> 
        </DialogActions>
      </form>
    </>
  );
};

export default connect(
  (state) => ({
    courseList: state.students.get("commonCourseList"),
  }),
  {
    getCourseList: Actions.students.getCourseList,
  }
)(AdminwebinarForm);
